import React from 'react'
import {ReactComponent as FeatureIcon} from '../../../assets/icons/feature.svg'

const ProductCard = ({product, onClick}) => {
    const {title, sku, image, price, attributes, fulfillment_location: fulfillmentLocation, tags = []} = product
    const badgeTags = tags.filter((tag) => tag !== 'Unisex')

    return (
        <div className="product-card" onClick={onClick}>
            <div className="product-image">
                <img src={image} alt={title} />
                <div className="product-tag">
                    {badgeTags.map((tag, index) => (
                        <div key={index} className={`product-tag-item ${tag}`}>
                            {tag}
                        </div>
                    ))}
                </div>
            </div>

            <div className="product-info">
                <h5>{title}</h5>

                <div className="product-price">
                    {/* <span className="original-price">${price.max}</span> */}
                    <span className="current-price">${price.min}</span>
                </div>

                <div className="product-meta">
                    <span>
                        <strong>SKU:</strong> {sku}
                    </span>
                </div>

                <div className="product-meta">
                    <span>
                        <strong>Fulfillment location:</strong> {fulfillmentLocation?.code || 'N/A'}
                    </span>
                </div>

                <div className="product-badges mb-3">
                    {attributes.map((attr, index) => (
                        <span key={index} className="badge">
                            {`${attr.values.length} ${attr.value_type}s`}
                        </span>
                    ))}
                </div>
            </div>

            {/* <div className="product-feature">
                <div className="feature-badge" style={{backgroundColor: badgeColor}}>
                    <FeatureIcon />
                    <span>{badge}</span>
                </div>
            </div> */}
        </div>
    )
}

export default ProductCard

